<template>
  <div class="container-fluid">
    <div class="row" style="height: 100%; overflow: hidden;">
      <div class="col-md-6 col-lg-4">
        <div class="combined-component">
          <i class="fa fa-search" />
          <input v-model="searchField" class="input" @change="updateNotes()" />
        </div>
        <ul class="notelist">
          <router-link
            v-for="(note, index) in notes"
            :key="index"
            :to="'/notes/' + note.id"
            custom
          >
            <NoteItem 
              :note="note" 
              :is-selected="isCombinedView() && selectedNoteId != null && note.id === selectedNoteId"
              @click="openNote(note.id, note.title)" 
            />
          </router-link>
        </ul>
      </div>
      <div class="note-editor-container d-none d-md-block col-md-6 col-lg-8">
        <NoteEditor
          v-if="selectedNoteId !== null"
          :id="selectedNoteId"
          ref="noteEditor"
          :embedded="true"
          @delete="clearNote()"
        />
      </div>
    </div>
    <div class="fixed bottom-right">
      <button id="btn-add-note" class="btn-big-circle" @click="createNote">
        <i class="fa fa-plus" />
      </button>
    </div>
  </div>
</template>

<script>
import NoteItem from '@/components/NoteItem.vue';
import NoteEditor from '@/components/NoteEditor.vue';
import { setWindowTitle } from '@/services/WindowService';

export default {
  components: { NoteItem, NoteEditor },
  data: function () {
    return {
      notes: [],
      searchField: '',
      selectedNoteId: null,
    };
  },
  mounted: function () {
    setWindowTitle('ChronoTASK: ' + this.$t.get('Notes'));
    this.emitter.on('notes-page:note-updated', (noteData) => {
      if (noteData == null) {
        this.updateNotes();
        return;
      }
      for (let i = 0; i < this.notes.length; i++) {
        if (this.notes[i].id === noteData.id) {
          this.notes[i].title = noteData.title;
          this.notes[i].text = noteData.text;
          break;
        }
      }
    });
    this.emitter.on('notes-page:note-deleted', (id) => {
      for (let i = 0; i < this.notes.length; i++) {
        if (this.notes[i].id === id) {
          this.notes.splice(i, 1);
          break;
        }
      }
    });
    this.updateNotes();
    if (this.$route.params.id) {
      this.selectNote(this.$route.params.id);
    }
  },
  methods: {
    updateNotes: function () {
      return this.$api
        .get('/notes', {
          q: this.searchField,
        })
        .then((res) => {
          this.notes = res.data;
          if (this.$route.params.id) {
            this.selectNote(this.$route.params.id);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    createNote: function () {
      this.$api
        .post('/notes')
        .then((res) => {
          // Pass a callback to open the note once the notes list is updated
          this.updateNotes().then(() => {
            this.openNote(res.data.id, res.data.title);
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    clearNote() {
      if (this.isCombinedView()) {
        this.$router.push('/notes');
      }
      this.selectedNoteId = null;
    },
    selectNote: function (id) {
      if (id == null) {
        this.clearNote();
        return;
      }

      let changed = this.selectedNoteId != id.toString();
      if (!changed) {
        return;
      }
      this.selectedNoteId = id.toString();
    },
    getNotePath: function (id) {
      return '/notes/edit/' + id;
    },
    isCombinedView() {
      return window.innerWidth > 768;
    },
    openNote: function (id, title) {
      if (this.isCombinedView()) {
        this.$router.push(`/notes/${id}`);
        this.selectNote(id);
      } else if (window.isElectron){
        this.$root.openPopup(this.getNotePath(id), title);
      } else {
        this.$router.push(this.getNotePath(id));
      }
    },
  },
};
</script>

<style scoped>
.notelist {
  padding: 0px;
  margin: 0px;
  list-style: none;
  overflow-y: scroll; height: calc(100vh - 150px);
}

.notelist a {
  text-decoration: none;
  font-weight: normal;
  color: unset;
}

.combined-component {
  display: flex;
  align-items: center;
  border: 1px solid #aaa;
  border-radius: 4px;
  margin: 4px;
}
.combined-component i {
  margin: 0px 4px;
}
.combined-component input {
  border: 0px;
  width: 100%;
  margin: 0px 4px;
}

.note-editor-container {
  position: relative;

  > .note-editor {
    top: 4px;
  }
}
</style>
